export const countConversationsAssigned = {
  analysisType: 'count',
  eventCollection: 'conversation.assigned',
  key: 'countConversationsAssigned',
}
